import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import './TOMi8ApiDocs.css';

const specUrl = `${process.env.PUBLIC_URL || ''}/tomi8-api/openapi.json`;

function TOMi8ApiDocs() {
  return (
    <div className="tomi8-api-docs px-2 px-md-3 py-3">
      <div className="tomi8-api-docs__swagger">
        <SwaggerUI
          url={specUrl}
          tryItOutEnabled={false}
          deepLinking
          docExpansion="list"
          defaultModelsExpandDepth={1}
        />
      </div>
    </div>
  );
}

export default TOMi8ApiDocs;
